import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BtnType, IconType, ModalType} from "../../model/kamonal-model";

@Component({
  selector: 'app-kamona-message-widget',
  templateUrl: './kamona-message-widget.component.html',
  styleUrls: ['./kamona-message-widget.component.scss']
})
export class KamonaMessageWidgetComponent implements OnInit, OnDestroy {

	@Input() title: string;
	@Input() description: string;
	@Input() iconType: IconType;
	readonly IconType = IconType;
	@Input() btnText = 'Dismiss';
	@Input() btnType = BtnType.SECONDARY;
	@Output() emitCancel = new EventEmitter ();
	readonly BtnType = BtnType;
	@Input() suspensionReleaseTimeEpoch: number;
	@Input() suspensionDescription = 'Try again in';
	ModalType = ModalType;
	@Input() modalType = ModalType.DEFAULT;
	countdown: any;
	countdownInterval: any;
	constructor() { }

	ngOnInit(): void {
	}


	showModal(){
		const modal: any = this.getModal();
		modal?.showModal();
		modal.addEventListener('cancel', (event) => {
			event.preventDefault();
		});
	}

	getModal(){}

	initialize(){
		this.clearRunningIntervals();
		if(this.suspensionReleaseTimeEpoch) {
			this.startCountDown();
		}
	}

	startCountDown(){
		const futureDate = this.suspensionReleaseTimeEpoch;
		this.countdown = this.getTimeRemaining(futureDate);
		this.countdownInterval = this.setCountdownInterval(futureDate);
	}

	getTimeRemaining(endTime: number) {
		const newDate = new Date(endTime).toUTCString();
		const total = Date.parse(newDate.toString()) - Date.parse(new Date().toString());
		const seconds = Math.floor((total / 1000) % 60);
		const minutes = Math.floor((total / 1000 / 60) % 60);
		const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
		const days = Math.floor(total / (1000 * 60 * 60 * 24));
		if (total <= 0) {
			return {total: 0, days: 0, hours: 0, minutes: 0, seconds: 0};
		}
		return {total, days, hours, minutes, seconds};
	}



	setCountdownInterval(futureDate: number){
		return  setInterval(() => {
			this.countdown = this.getTimeRemaining(futureDate);
		}, 1000);
	}

	clearRunningIntervals() {
		clearInterval(this.countdownInterval);
		this.countdown = undefined;
	}

	dismiss(){
		this.emitCancel.emit();
	}

	ngOnDestroy(): void {
		this.clearRunningIntervals();
	}

}
